export default __webpack_public_path__ + "static/media/png-file.5c20a345.svg";